import styled from 'styled-components'
import PopoverMenu from 'src/components/PopoverMenu'

export const Dropdown = styled(PopoverMenu)`
  min-width: 14.5rem !important;
  top: 100% !important;

  button {
    &:focus {
      outline: 2px solid var(--blue);
      outline-offset: -2px;
    }

    &:first-child {
      border-radius: var(--border-radius-lg) var(--border-radius-lg) 0 0;
    }

    &:last-child {
      border-radius: 0 0 var(--border-radius-lg) var(--border-radius-lg);
    }
  }
`

Dropdown.displayName = 'Dropdown'
